module.exports = __webpack_public_path__ + "img/heavy_armor_6.4d821cde.png";